import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { Card } from '../../../../components/common/Card'
import { CardBody } from '../../../../components/common/Card/CardBody'
import { Button, ButtonVariant } from '../../../../components/common/Button'
import { useModal } from '../../../../hooks/useModal'
import { adminQueries } from '../../../../api/admin'
import { theme } from '../../../../theme/theme'
import { CreateDiscountModal } from './CreateDiscountModal'
import { UpdateDiscountModal } from './UpdateDiscountModal'
import { NAdmin } from '../../../../interfaces/services/admin.interfaces'

export const DiscountCodes = (): React.ReactNode => {
  const [selectedDiscount, setSelectedDiscount] = React.useState<
    NAdmin.NGetDiscount.IResponseInternal[number] | null
  >(null)
  const {
    show: showCreateModal,
    open: openCreateModal,
    close: closeCreateModal,
  } = useModal()
  const {
    show: showEditModal,
    open: openEditModal,
    close: closeEditModal,
  } = useModal()

  const { data: discountCodes } = useQuery(adminQueries.getDiscountCodes())

  const closeUpdateModal = (): void => {
    closeEditModal()
    setSelectedDiscount(null)
  }

  return (
    <>
      <div className="h-5/6 w-full">
        <Button
          className="mb-4"
          variant={ButtonVariant.PRIMARY}
          label="Skapa rabattkod"
          onClick={openCreateModal}
        />
        <div className="gap-4 flex flex-col">
          {discountCodes?.map((discountCode) => (
            <Card
              key={discountCode.code}
              className="w-[480px]"
              onClick={() => {
                setSelectedDiscount(discountCode)
                openEditModal()
              }}
            >
              {{
                body: (
                  <CardBody className="flex flex-row flex-wrap justify-center gap-x-2 gap-y-1">
                    <p style={theme.textVariants.baseBold}>
                      {discountCode.code}
                    </p>
                    <p style={theme.textVariants.base}>
                      {discountCode.discount}%
                    </p>
                    <p style={theme.textVariants.base}>
                      {discountCode.partnerName}
                    </p>
                    <p style={theme.textVariants.base}>
                      {discountCode.articleNo}
                    </p>
                    <p style={theme.textVariants.base}>
                      {discountCode.societyCount} föreningar
                    </p>
                  </CardBody>
                ),
              }}
            </Card>
          ))}
        </div>
      </div>

      {showCreateModal && (
        <CreateDiscountModal show={showCreateModal} close={closeCreateModal} />
      )}

      {showEditModal && selectedDiscount && (
        <UpdateDiscountModal
          show={showEditModal}
          close={closeUpdateModal}
          discount={selectedDiscount}
        />
      )}
    </>
  )
}
